import { RootState } from 'types';

import { initialState } from '.';

// First select the relevant part from the state
const selectProfileState = (state: RootState) => state?.profile || initialState;

export default selectProfileState;
